/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BulkTagRemediationStatusResponse {
    getFixupPrototypeFunction() { return BulkTagRemediationStatusResponse.fixupPrototype; }

    static newInstance(model: Partial<BulkTagRemediationStatusResponse>): BulkTagRemediationStatusResponse {
        let obj = Object.assign(new BulkTagRemediationStatusResponse(), model);
        BulkTagRemediationStatusResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BulkTagRemediationStatusResponse>): BulkTagRemediationStatusResponse {
        if (!model) return null;
        return BulkTagRemediationStatusResponse.newInstance(<BulkTagRemediationStatusResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BulkTagRemediationStatusResponse) {
        if (!obj) return;

        models.BulkTagRemediationStatusResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BulkTagRemediationStatusResponse): boolean {
        Object.setPrototypeOf(obj, BulkTagRemediationStatusResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.TagRemediationStatus.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.TagRemediationStatus; };

}
